<template>
  <div class="page_content job-viewers-page">
    <job-header :uuid="uuid"></job-header>
    <div class="course-management-section">
      <div class="viewers-toolbar">
        <div class="toolbar-left">
          <h2 class="head_txt module_type_name ace_sec_hd">{{ $t('viewers') }} [{{ filteredViewers.length }}]</h2>
        </div>
        <div class="toolbar-right">
          <!--
          <div class="out-of-total-item ace_sec_txt">
            <div>{{ filteredViewers.length }} {{ $t('viewers').toLowerCase() }}</div>
          </div>
          -->
          <div class="number-of-item ace_sec_txt">
            <b-dropdown id="viewersSizeDropdown" :text="'' + pageSize" :aria-label="$t('numberOfItem')">
              <template v-for="(option, index) in sizeOptions">
                <b-dropdown-divider v-if="index > 0" :key="'divider-' + option"></b-dropdown-divider>
                <b-dropdown-item :key="'size-' + option" @click="changeSize(option)">{{ option }} {{ $t('itemPerPage') }}</b-dropdown-item>
              </template>
            </b-dropdown>
          </div>
          <div class="pagination btn_container pagination_sty3">
            <button type="button" class="btn btn_trans" :disabled="firstPage" @click="prev" @keydown.enter="prev" :title="$t('previousPage')" :aria-label="$t('previousPage')"><span class="ic2_arr_pre3" aria-hidden="true"></span></button>
            <span class="current-page ace_sec_txt">{{ page + 1 }}</span>
            <button type="button" class="btn btn_trans" :disabled="lastPage" @click="next" @keydown.enter="next" :title="$t('nextPage')" :aria-label="$t('nextPage')"><span class="ic2_arr_next3" aria-hidden="true"></span></button>
          </div>

          <div class="search-box-container">
            <input type="text" class="input-search" :placeholder="$t('typeToNarrowResults')" v-on:keypress.enter="searchButtonClicked" v-model.trim="searchTerms" :aria-label="$t('typeToNarrowResults')">
            <button class="btn btn_srh" @click="searchButtonClicked" :aria-label="$t('goAria')">
              <span class="ic_srh ic_search" aria-hidden="true"></span>
            </button>
            <button id="viewersSortByDropDown" type="button" @click="toggleSortByDropDown" class="sort-by ace_sec" :aria-label="$t('sort')">
              <span class="ic2_sort2 sort-by-icon" aria-hidden="true"></span>
              <span class="txt_srt">{{ $t('sort') }}</span>
            </button>
            <div id="viewersSortPopup" class="sort_by_popover"></div>
          </div>
          <b-popover target="viewersSortByDropDown" :show.sync="showSortByDropDown" container="viewersSortPopup" triggers="blur">
            <div class="header-content-row">
              <span class="title">{{ $t('sortBy') }}</span>
            </div>
            <template v-for="sort in sorts">
              <div class="field-row" :key="sort.name">
                <div class="form-check">
                  <input type="radio" class="form-check-input" :id="'viewer-sort-' + sort.name" v-model="selectedSortName" :value="sort.name">
                  <label class="form-check-label" :for="'viewer-sort-' + sort.name">{{ sort.labelKey ? $t(sort.labelKey) : sort.name }}</label>
                </div>
              </div>
            </template>
            <b-btn @click="sortOkClicked" class="range-button">{{ $t('ok') }}</b-btn>
          </b-popover>
        </div>
      </div>

      <div class="viewers-body">
        <div class="viewers-list-pane">
          <div v-if="pagedViewers.length > 0" class="viewers-list">
            <div
              class="viewer-row"
              v-for="(viewer, index) in pagedViewers"
              :key="viewerKey(viewer) || index"
              :class="{ 'is-selected': isSelected(viewer) }"
              @click="selectViewer(viewer)">
              <div class="viewer-name-row">
                <div class="viewer-avatar" :style="{ background: avatarColor(index) }">
                  <span class="icon-user"></span>
                </div>
                <div class="viewer-name ace_sec_txt">{{ viewerName(viewer) }}</div>
              </div>
              <div class="viewer-institution" v-if="institutionTitle(viewer) || institutionLogo(viewer)">
                <div
                  class="institution-avatar"
                  :class="{ 'has-logo': institutionLogo(viewer) }"
                  :style="institutionLogo(viewer) ? null : { background: avatarColor(index + 1) }">
                  <img
                    v-if="institutionLogo(viewer)"
                    :src="institutionLogo(viewer)"
                    :alt="institutionTitle(viewer)">
                  <span v-else>{{ institutionInitials(institutionTitle(viewer)) }}</span>
                </div>
                <div class="institution-name ace_sec_txt">{{ institutionTitle(viewer) }}</div>
              </div>
              <div class="viewer-date-row">
                <div class="viewer-meta-item">
                  <span class="viewed-icon" aria-hidden="true">
                    <span class="ic22-eye"></span>
                  </span>
                  <div class="viewed-date ace_sec_txt">{{ viewerViewCount(viewer) }}</div>
                </div>
                <div class="viewer-meta-item">
                  <span class="viewed-icon" aria-hidden="true">
                    <span class="ic2_calendar"></span>
                  </span>
                  <div class="viewed-date ace_sec_txt">{{ viewedDateLabel(viewer) }}</div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="no-result ace_sec_txt" style="text-align: center;">{{ $t('noResult') }}</div>
        </div>
        <div class="viewers-details-pane">
          <template v-if="selectedViewer">
            <div class="details-header">
              <div class="details-viewer">
                <div class="viewer-avatar details-user-avatar" :style="{ background: avatarColor(selectedViewerIndex) }">
                  <span class="icon-user"></span>
                </div>
                <span class="details-viewer-name ace_sec_txt">{{ viewerName(selectedViewer) }}</span>
              </div>
            </div>
            <div class="details-tab-content">
              <job-applicant-profile
                :key="'viewer-profile-' + selectedViewerUserId"
                :applicant-id="selectedViewerUserId">
              </job-applicant-profile>
            </div>
          </template>
          <div v-else class="viewers-details-empty ace_sec_txt">
            {{ $t('selectViewerToViewProfile') }}
          </div>
        </div>
      </div>
    </div>
    <div class="loading-spinner">
      <b-modal style="padding: 0px;" ref="loadingModal" hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
          <div class="text-center" style="color: #FFF">
              <i class="fa fa-spinner fa-spin" style="font-size: 50px"></i>
          </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import { DateTime } from 'luxon'
  import JobHeader from './JobHeader'
  import JobApplicantProfile from './JobApplicantProfile'
  import '../../../assets/module/sass/course/courseList.scss'

  export default {
    name: 'jobViewers',
    props: ['uuid'],
    components: {
      JobHeader,
      JobApplicantProfile
    },
    data: () => {
      return {
        jobViewers: [],
        pageSize: 20,
        sizeOptions: [20, 50, 100],
        firstPage: true,
        lastPage: true,
        page: 0,
        searchTerms: '',
        appliedSearch: '',
        selectedViewerKey: null,
        showSortByDropDown: false,
        selectedSortName: 'Viewer',
        sorts: [
          { name: 'Viewer' },
          { name: 'Last Viewed On', labelKey: 'viewedOn' },
          { name: 'Views' },
          { name: 'Institution' }
        ],
        avatarColors: ['#5a6a7a', '#7ab8d4', '#e08a4a']
      }
    },
    mounted () {
      this.loadJobViewers()
    },
    methods: {
      ...mapActions([
        'getAllJobActivity'
      ]),
      loadJobViewers () {
        this.showLoader()
        if (!this.uuid) {
          this.jobViewers = []
          this.updatePaging()
          this.hideLoader()
          return
        }
        this.getAllJobActivity(this.uuid).then(res => {
          this.jobViewers = this.dedupeViewers(this.normalizeViewers(res))
          this.page = 0
          this.updatePaging()
          this.syncSelectedViewer()
          this.hideLoader()
        })
      },
      normalizeViewers (res) {
        let list = []
        if (!res) {
          return list
        }
        if (res.content && res.content.length >= 0) {
          list = res.content
        } else if (res.length >= 0) {
          list = res
        } else if (res.userId || res.userFullName) {
          list = [res]
        }
        return list.filter((item) => {
          return !item.type || item.type === 'View'
        })
      },
      dedupeViewers (list) {
        let byUser = {}
        list.forEach((item) => {
          let id = item.userId || item.userUuid || item.uuid
          if (!id) {
            return
          }
          let existing = byUser[id]
          let time = this.viewedTime(item) || 0
          if (!existing || time > (this.viewedTime(existing) || 0)) {
            byUser[id] = item
          }
        })
        return Object.keys(byUser).map((key) => {
          return byUser[key]
        })
      },
      updatePaging () {
        let totalPages = Math.ceil(this.filteredViewers.length / this.pageSize)
        if (totalPages < 1) {
          totalPages = 1
        }
        if (this.page > totalPages - 1) {
          this.page = totalPages - 1
        }
        this.firstPage = this.page <= 0
        this.lastPage = this.page >= totalPages - 1
      },
      searchButtonClicked () {
        this.appliedSearch = this.searchTerms
        this.resetPage()
      },
      toggleSortByDropDown () {
        this.showSortByDropDown = !this.showSortByDropDown
      },
      sortOkClicked () {
        this.showSortByDropDown = false
        this.resetPage()
      },
      changeSize (option) {
        this.pageSize = option
        this.resetPage()
      },
      sortViewers (list) {
        let sorted = list.slice()
        let name = this.selectedSortName
        sorted.sort((a, b) => {
          if (name === 'Last Viewed On') {
            return (this.viewedTime(b) || 0) - (this.viewedTime(a) || 0)
          }
          if (name === 'Views') {
            return (this.viewerViewCount(b) || 0) - (this.viewerViewCount(a) || 0)
          }
          if (name === 'Institution') {
            return (this.institutionTitle(a) || '').localeCompare(this.institutionTitle(b) || '')
          }
          return (this.viewerName(a) || '').localeCompare(this.viewerName(b) || '')
        })
        return sorted
      },
      resetPage () {
        this.page = 0
        this.updatePaging()
      },
      prev () {
        if (this.firstPage) {
          return
        }
        this.page -= 1
        this.updatePaging()
      },
      next () {
        if (this.lastPage) {
          return
        }
        this.page += 1
        this.updatePaging()
      },
      viewedTime (viewer) {
        if (!viewer) {
          return null
        }
        return viewer.creationTime || viewer.viewedOn || viewer.lastUpdatedTime || viewer.viewedTime
      },
      viewedDateLabel (viewer) {
        let millis = this.viewedTime(viewer)
        if (!millis) {
          return this.$t('na')
        }
        return DateTime.fromMillis(millis).toFormat('MM/dd/yyyy')
      },
      viewerViewCount (viewer) {
        if (!viewer || viewer.viewCount === undefined || viewer.viewCount === null || viewer.viewCount === '') {
          return 0
        }
        return viewer.viewCount
      },
      showLoader () {
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.show()
        }
      },
      hideLoader () {
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.hide()
        }
      },
      viewerKey (viewer) {
        if (!viewer) {
          return ''
        }
        return viewer.uuid || viewer.activityUuid || viewer.userId || viewer.userUuid || ''
      },
      viewerUserId (viewer) {
        if (!viewer) {
          return ''
        }
        return viewer.userId || viewer.userUuid || ''
      },
      viewerName (viewer) {
        if (!viewer) {
          return ''
        }
        return viewer.userFullName || viewer.userName || ''
      },
      selectViewer (viewer) {
        this.selectedViewerKey = this.viewerKey(viewer)
      },
      isSelected (viewer) {
        return this.viewerKey(viewer) === this.selectedViewerKey
      },
      syncSelectedViewer () {
        if (!this.jobViewers || this.jobViewers.length === 0) {
          this.selectedViewerKey = null
          return
        }
        if (this.selectedViewerKey) {
          let stillVisible = this.jobViewers.some((item) => {
            return this.viewerKey(item) === this.selectedViewerKey
          })
          if (!stillVisible) {
            this.selectedViewerKey = this.viewerKey(this.jobViewers[0])
          }
          return
        }
        this.selectedViewerKey = this.viewerKey(this.jobViewers[0])
      },
      avatarColor (index) {
        return this.avatarColors[index % this.avatarColors.length]
      },
      institutionTitle (viewer) {
        if (!viewer) {
          return ''
        }
        return viewer.institutionTitle || ''
      },
      institutionLogo (viewer) {
        if (!viewer) {
          return ''
        }
        return viewer.institutionLogo || ''
      },
      institutionInitials (title) {
        if (!title) {
          return ''
        }
        let first = title.trim().split(/\s+/)[0]
        if (first.length <= 4) {
          return first.toUpperCase()
        }
        return first.substring(0, 3).toUpperCase()
      }
    },
    computed: {
      filteredViewers () {
        let list = this.jobViewers || []
        if (this.appliedSearch) {
          let term = this.appliedSearch.toLowerCase()
          list = list.filter((viewer) => {
            let name = this.viewerName(viewer) || ''
            let institution = this.institutionTitle(viewer) || ''
            return name.toLowerCase().indexOf(term) !== -1 || institution.toLowerCase().indexOf(term) !== -1
          })
        }
        return this.sortViewers(list)
      },
      pagedViewers () {
        let start = this.page * this.pageSize
        return this.filteredViewers.slice(start, start + this.pageSize)
      },
      selectedViewer () {
        if (!this.selectedViewerKey) {
          return null
        }
        let selected = this.jobViewers.find((item) => {
          return this.viewerKey(item) === this.selectedViewerKey
        })
        return selected || null
      },
      selectedViewerIndex () {
        if (!this.selectedViewerKey) {
          return 0
        }
        let index = this.pagedViewers.findIndex((item) => {
          return this.viewerKey(item) === this.selectedViewerKey
        })
        return index < 0 ? 0 : index
      },
      selectedViewerUserId () {
        return this.viewerUserId(this.selectedViewer)
      }
    },
    watch: {
      uuid () {
        this.loadJobViewers()
      }
    }
  }
</script>

<style scoped>
  .page_content.job-viewers-page {
    height: calc(100vh - 134px);
    overflow: hidden;
    display: flex;
    flex-direction: column;
    padding-right: 0;
  }

  .page_content >>> .page-heading.pg_hd {
    flex: 0 0 auto;
    margin-bottom: 0;
  }

  .course-management-section {
    flex: 1 1 auto;
    min-height: 0;
    display: flex;
    flex-direction: column;
    margin-top: 0;
    padding: 0 0 0 20px;
    overflow: hidden;
  }

  .viewers-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 6px 20px 6px 0;
    border-bottom: 1px solid #ebebeb;
    background: #fff;
    flex-wrap: nowrap;
    flex: 0 0 auto;
  }

  .toolbar-left,
  .toolbar-right {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
  }

  .toolbar-right .out-of-total-item {
    margin-right: 10px;
    white-space: nowrap;
  }

  .toolbar-right .number-of-item {
    margin-right: 10px;
  }

  .toolbar-right .number-of-item >>> .dropdown-toggle {
    height: 32px;
    padding: 0 12px;
    border: none;
    color: #fff;
  }

  .toolbar-right .pagination {
    display: flex;
    align-items: center;
    margin-right: 12px;
    margin-top: 0;
    padding-top: 0;
  }



  .toolbar-right .search-box-container {
    display: flex;
    align-items: center;
    width: auto;
    float: none;
  }

  .viewers-body {
    display: flex;
    align-items: stretch;
    width: 100%;
    flex: 1 1 auto;
    min-height: 0;
    overflow: hidden;
  }

  .viewers-list-pane {
    width: 30%;
    min-width: 0;
    overflow-x: hidden;
    overflow-y: auto;
    height: 100%;
    min-height: 0;
    padding-top: 12px;
    padding-bottom: 12px;
  }

  .viewers-details-pane {
    width: 70%;
    min-width: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    height: 100%;
    min-height: 0;
    border-left: 1px solid #ebebeb;
    background: #fff;
  }

  .details-tab-content {
    flex: 1 1 auto;
    min-height: 0;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .viewers-details-empty {
    padding: 24px 16px;
  }

  .details-header {
    flex: 0 0 auto;
    border-bottom: 1px solid #ebebeb;
    padding: 8px 16px 6px;
  }

  .details-viewer {
    display: flex;
    align-items: center;
    min-width: 0;
    margin: 0;
  }

  .details-user-avatar {
    width: 28px;
    height: 28px;
    min-width: 28px;
    border-radius: 4px;
    margin-right: 10px;
  }

  .details-user-avatar .icon-user {
    font-size: 16px;
    color: #fff;
  }

  .details-viewer-name {
    font-size: 16px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .viewer-row {
    position: relative;
    padding: 16px 18px;
    margin: 0 20px 12px 16px;
    cursor: pointer;
    background: #fff;
    border: 1px solid #d4d4d4;
    border-radius: 16px;
  }

  .viewer-row:hover,
  .viewer-row:focus {
    background: #fff;
  }

  .viewer-row.is-selected,
  .viewer-row.is-selected:hover,
  .viewer-row.is-selected:focus {
    background: #f3f3f3;
  }

  .viewer-row.is-selected:after {
    content: '';
    position: absolute;
    top: 50%;
    right: -8px;
    width: 14px;
    height: 14px;
    background: #f3f3f3;
    border-top: 1px solid #d4d4d4;
    border-right: 1px solid #d4d4d4;
    transform: translateY(-50%) rotate(45deg);
    z-index: 1;
  }

  .viewer-name-row,
  .viewer-institution {
    display: flex;
    align-items: center;
    min-width: 0;
  }

  .viewer-date-row {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    align-items: center;
    column-gap: 8px;
    min-width: 0;
  }

  .viewer-meta-item {
    display: flex;
    align-items: center;
    min-width: 0;
    overflow: hidden;
  }

  .viewer-name-row {
    margin-bottom: 15px;
  }

  .viewer-institution {
    margin-bottom: 15px;
  }

  .viewer-avatar,
  .institution-avatar,
  .viewed-icon {
    width: 22px;
    height: 22px;
    min-width: 22px;
    margin-right: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .viewer-avatar {
    border-radius: 4px;
    color: #fff;
  }

  .viewer-avatar .icon-user {
    font-size: 14px;
    color: #fff;
  }

  .viewer-name,
  .institution-name,
  .viewed-date {
    font-size: 16px;
    font-weight: 400;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .institution-avatar {
    border-radius: 4px;
    color: #fff;
    font-size: 8px;
    font-weight: 600;
    overflow: hidden;
  }

  .institution-avatar.has-logo {
    background: #f2f2f2;
  }

  .institution-avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .viewed-icon {
    height: 22px;
    font-size: 16px;
  }
</style>

<style>
  .page_content_container:has(.job-viewers-page) {
    overflow: hidden;
    padding-bottom: 0;
    padding-right: 0;
  }

  .job-viewers-page .sort_by_popover .popover {
    transform: none !important;
    min-width: 240px;
  }
</style>



// WEBPACK FOOTER //
// src/app/job/components/JobViewers.vue